import { useSelector } from 'react-redux';
import { getCaseBattleType } from '../ducks';

export const useGetCaseBattleType = () => ({
  battleType: useSelector(getCaseBattleType),
});
